import { withStyles } from '@material-ui/core';

import { CommentsListItem as InnerCommentsListItem } from './CommentsListItem';
import { commentsListItemStyles } from './commentsListItemStyles';

export const CommentsListItem = withStyles(commentsListItemStyles)(InnerCommentsListItem);
